package com.eladfinish.bible.contest.ads

import com.eladfinish.bible.contest.constants.SharedPrefsConstants
import com.eladfinish.bible.contest.currentMilliseconds
import com.eladfinish.bible.contest.platform.isAndroid
import com.eladfinish.bible.contest.platform.isIos
import com.eladfinish.contract.analytics.AdFreeState
import com.russhwolf.settings.Settings

/**
 * Why ads are or are not showing, for analytics. Reads the same preferences as
 * [ShouldShowAdsUseCase], and a purchase wins over the rewarded window when both apply.
 */
class GetAdFreeStateUseCase(
    private val settings: Settings,
    private val hasAdsSdk: Boolean = isAndroid || isIos,
) {
    operator fun invoke(): String {
        if (!hasAdsSdk) return AdFreeState.NO_ADS_PLATFORM
        if (settings.getBoolean(SharedPrefsConstants.AD_FREE_PURCHASED, false)) return AdFreeState.PURCHASED
        val adFreeUntil = settings.getLong(SharedPrefsConstants.AD_FREE_UNTIL_MILLIS, 0L)
        if (currentMilliseconds < adFreeUntil) return AdFreeState.REWARD_WINDOW
        return AdFreeState.NONE
    }
}
